import React from 'react';
import {areArraysEqual} from "core/common/utils/arrayUtils";
import {topDifference} from "core/common/utils/domUtils";
import {observer} from "mobx-react";
import {GridData, GridRow, PageMapIndex, ROW_HEIGHT} from "core/grid/domain/grid";
import throtlle = require("lodash/throttle");

interface VirtualListProps {
  gridData: GridData;
  renderItem: any;
  container: any;
  header: any;
  search: (page: number) => any;
}

interface VirtualListState {
  items: any[];
  bufferStart: number;
  height: number;
}

type TRenderStats = {
  firstIndex: PageMapIndex
  lastIndex: PageMapIndex;
};

@observer
export default class VirtualList extends React.Component<VirtualListProps, VirtualListState> {


  static defaultProps = {
    container: typeof window !== 'undefined' ? window : undefined,
  };


  _isMounted: boolean;
  onScrollThrottled: any;
  mainRef: any;



  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.bufferStart !== nextState.bufferStart) {
      //console.log('state.bufferStart se lisi, returning TRUE');
      return true;
    }
    if (this.state.height !== nextState.height) {
      //console.log('state.height se lisi, returning TRUE');
      return true;
    }
    let equal = areArraysEqual(this.state.items, nextState.items);
    //console.log('state.items array returning ' + !equal);
    return !equal;
  }

  componentWillReceiveProps(nextProps) {
    console.log('virtualList#componentWillReceiveProps %O', nextProps);
    let state = this.getVirtualState(nextProps);
    this.setState(state);
  }

  componentWillMount() {
    //console.log('virtualList#componentWillMount %O', this.props);
    this.onScrollThrottled = throtlle(this.onScroll, 60);
    let state = this.getVirtualState(this.props);
    this.setState(state);
  }

  componentDidMount() {

    this._isMounted = true;

    let state = this.getVirtualState(this.props);

    console.log('virtualList#componentDidMount state = %O', state);

    this.setState(state);

    this.props.container.addEventListener('scroll', this.onScrollThrottled, {passive: true});

    window.addEventListener('resize', this.onResize);

  }

  remountScroll(container) {  // hack kvuli remountovani pri zmene rozliseni
    console.log('remountScroll %O', container);
    container.addEventListener('scroll', this.onScrollThrottled, {passive: true});
  }

  componentWillUnmount() {
    //console.log('virtualList#componentWillUnmount %O', this.props);
    this._isMounted = undefined;
    this.props.container.removeEventListener('scroll', this.onScrollThrottled);
    window.removeEventListener('resize', this.onResize);
  }

  onScroll = () => {
    let state = this.getVirtualState(this.props);
    this.setState(state);
    // v pripade ze je header, posuneme ho do spravne pozice
    if (this.props.header) { this.props.header.style.left = -this.props.container.scrollLeft + 'px'; }
  };


  onResize =() => {
    window.requestAnimationFrame(() => {
      let state = this.getVirtualState(this.props);
      this.setState(state);
    });
  };

  // in case you need to get the currently visible items
  visibleItems() {
    return this.state.items;
  }

  scrollTop() {
    this.props.container.scrollTop = 0;
  }

  mainRefHandler = (comp) => this.mainRef = comp;


  render() {
    //console.log("%cVirtualList#render: items.length = " + this.state.items.length, "background-color: red");
    try {
      return (
        <div ref={this.mainRefHandler}  style={{boxSizing: 'border-box', height: this.state.height, paddingTop: this.state.bufferStart }} >
          {this.state.items.map(this.props.renderItem)}
        </div>
      );
    } catch(err) {
      console.error('Error in render item: ', err);
    }
  }




  getVirtualState(props: VirtualListProps): VirtualListState {

    let {gridData, container, search} = props;

    // default values
    let state = {
      items: [],
      bufferStart: 0,
      height: 0
    };

    // early return if nothing to render
    if (typeof container === 'undefined' || gridData.isEmpty() || !this._isMounted) return state;


    //let items = props.items;

    state.height =  this.virtualHeight(gridData);


    let viewHeight = typeof container.innerHeight !== 'undefined' ? container.innerHeight : container.clientHeight;

    // no space to render
    if (viewHeight <= 0) return state;

    let offsetTop: number = topDifference(this.mainRef, container);

    let viewTop: number = typeof container.scrollY !== 'undefined' ? container.scrollY : container.scrollTop;

    const renderStats = this.getItems(viewTop, viewHeight, offsetTop, gridData, state.height, search);

    if (renderStats) {
      console.log("firstLocalIndex = %s, lastLocalIndex = %s, firstPlaneIndex = %s, lastPlaneIndex = %s", renderStats.firstIndex.local, renderStats.lastIndex.local, renderStats.firstIndex.plane, renderStats.lastIndex.plane);
    }

    // no items to render
    if (!renderStats) return state;

    state.items = gridData.sliceSparse(renderStats.firstIndex, renderStats.lastIndex);

    state.bufferStart = this.virtualHeightTo(gridData, renderStats.firstIndex);

    //console.debug("getVirtualState: state.height = " + state.height + " on " + props.items.length + " total items.  State.items = " + state.items.length + ", state.bufferStart = " + state.bufferStart);

    return state;
  }



  getItems(viewTop: number, viewHeight: number, listTop: number, gridData: GridData, listHeight: number, search: (page: number) => any): TRenderStats {
    if (listHeight === 0) return null;


    let listBox = {
      top: listTop,
      height: listHeight,
      bottom: listTop + listHeight
    };



    let viewBox = {
      top: viewTop,
      bottom: viewTop + viewHeight
    };

    // list is below viewport
    if (viewBox.bottom < listBox.top) return null;

    // list is above viewport
    if (viewBox.top > listBox.bottom) return null;

    let listViewBox = this.getBox(viewBox, listBox);


    let firstLocalIndex = 0, lastLocalIndex = 0, firstPlaneIndex = 1, lastPlaneIndex = 1, runningHeight = 0;

    let remainingCount = gridData.totalCount;
    let page = 1;
    let pageSize = gridData.pageSize;
    while(remainingCount > 0) {

      firstLocalIndex = 0;
      lastLocalIndex = 0;

      if (runningHeight <= listViewBox.top) firstPlaneIndex = page;
      if (runningHeight <= listViewBox.bottom) lastPlaneIndex = page;

      let plane = gridData.pageMap.get(page.toString());
      if (plane) {
        for(let i = 0; i < plane.length; i++) {
          if (runningHeight <= listViewBox.top) firstLocalIndex = i;
          if (runningHeight <= listViewBox.bottom) lastLocalIndex = i;
          runningHeight += plane[i].rowHeight;
          if (runningHeight > listViewBox.bottom) return {firstIndex: {plane: firstPlaneIndex, local: firstLocalIndex}, lastIndex: {plane: lastPlaneIndex, local: lastLocalIndex}};
        }
      } else {
        // SEARCH NEEDED
        console.log("SEARCH NEEDED");
        search(page);

        for(let i = 0; i < pageSize; i++) {
          if (runningHeight <= listViewBox.top) firstLocalIndex = i;
          if (runningHeight <= listViewBox.bottom) lastLocalIndex = i;
          runningHeight += ROW_HEIGHT;
          if (runningHeight > listViewBox.bottom) return {firstIndex: {plane: firstPlaneIndex, local: firstLocalIndex}, lastIndex: {plane: lastPlaneIndex, local: lastLocalIndex}};
        }

      }


      remainingCount -= pageSize;
      page++;
      pageSize *= 2;
    }


    return {firstIndex: {plane: firstPlaneIndex, local: firstLocalIndex}, lastIndex: {plane: lastPlaneIndex, local: lastLocalIndex}};
  }

  private virtualHeight(gridData: GridData): number {
    let height = 0, realCount = 0;
    for(const plane of gridData.pageMap.values()) {
      height = plane.reduce((acc, row) => acc + row.rowHeight, height);
      realCount += plane.length;
    }
    return (height + (gridData.totalCount - realCount) * ROW_HEIGHT);
  }

  private virtualHeightTo(gridData: GridData, firstIndex: PageMapIndex): number {
    let height  = 0;
    let pageSize = gridData.pageSize;
    for(let page = 1; page <= firstIndex.plane; page++) {
      let plane = gridData.pageMap.get(page.toString());
      let _last = (page === firstIndex.plane) ? (firstIndex.local) : pageSize;
      if (plane) {
        for(let i = 0; i < _last; i++) height += plane[i].rowHeight;
      } else {
        height += _last * ROW_HEIGHT;
      }
      pageSize *= 2;
    }
    return height;
  }

  getBox(view, list): {top: number, bottom: number} {
    list.height = list.height || list.bottom - list.top;

    return {
      top: Math.max(0, Math.min(view.top - list.top)),
      bottom: Math.max(0, Math.min(list.height, view.bottom - list.top))
    };
  }


};




// WEBPACK FOOTER //
// ./src/core/grid/component/virtualList.tsx